import { PipelineFreshness } from "@/components/clicks/PipelineFreshness";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface AnalyticsHeaderProps {
  currentPreset: string;
  onFilterChange: (preset: string) => void;
}

export const AnalyticsHeader = ({
  currentPreset,
  onFilterChange,
}: AnalyticsHeaderProps) => {
  return (
    <div className="flex items-center justify-between space-y-2">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="text-3xl font-bold tracking-tight">Analytics</h2>
        <PipelineFreshness sources={["analytics_data"]} />
      </div>
      <div className="flex items-center space-x-2">
        <Select value={currentPreset} onValueChange={onFilterChange}>
          <SelectTrigger className="w-[180px] cursor-pointer border-border bg-card">
            <SelectValue placeholder="Select period" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem className="cursor-pointer" value="today">
              Today
            </SelectItem>
            <SelectItem className="cursor-pointer" value="yesterday">
              Yesterday
            </SelectItem>
            <SelectItem className="cursor-pointer" value="last_7_days">
              Last 7 days
            </SelectItem>
            <SelectItem className="cursor-pointer" value="last_14_days">
              Last 14 days
            </SelectItem>
            <SelectItem className="cursor-pointer" value="this_month">
              This month
            </SelectItem>
            <SelectItem className="cursor-pointer" value="last_month">
              Last month
            </SelectItem>
            <SelectItem className="cursor-pointer" value="all_time">
              All time
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

